import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { bool } from 'prop-types';
import { useLocation } from 'react-router-dom';

import { propTypes } from '../../util/types';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { runnerHubView } from '../../config/marketplaceContent';

import { Page, NoticeboardFeed, EndUserTradeTimeline, WalletLinkCallout } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import LandingNarrative from '../../components/Phase5/LandingNarrative';
import LivePipelineTicker from '../../components/Phase5/LivePipelineTicker';
import DualPaneLayout from './DualPaneLayout';
import LandingAssetMarket from './LandingAssetMarket';
import { TownHallFeed } from '../../components';

import css from './LandingPage.module.css';
import { resolveLandingViewMode } from './landingViewMode';

export { resolveLandingViewMode };

const ViewHeader = ({ eyebrow, title, subtitle }) => (
  <header className={css.viewHeader}>
    {eyebrow ? <p className={css.viewEyebrow}>{eyebrow}</p> : null}
    <h1 className={css.viewTitle}>{title}</h1>
    <p className={css.viewSubtitle}>{subtitle}</p>
  </header>
);

export const LandingPageComponent = props => {
  const { scrollingDisabled, isAuthenticated, currentUser } = props;
  const { pathname } = useLocation();
  const viewMode = resolveLandingViewMode(pathname);
  const isHome = viewMode === 'home';
  const isMarketplace = viewMode === 'marketplace';
  const isRunner = viewMode === 'runner';

  return (
    <Page
      title="BetterXchange"
      description="Sovereign peer-to-peer digital asset exchange and lending"
      scrollingDisabled={scrollingDisabled}
    >
      <TopbarContainer />
      <main id="main-content" className={css.pageContent}>
        {isHome || isRunner ? (
          <LivePipelineTicker isAuthenticated={isAuthenticated} />
        ) : null}

        <div className={css.contentWrap}>
          {isHome ? <LandingNarrative /> : null}

          {isHome ? (
            <DualPaneLayout
              className={css.dualPane}
              townHallPanel={
                <TownHallFeed isAuthenticated={isAuthenticated} currentUser={currentUser} />
              }
              marketPanel={<LandingAssetMarket />}
            />
          ) : null}

          {isMarketplace ? (
            <div className={css.marketplaceOnly}>
              <LandingAssetMarket variant="browse" />
            </div>
          ) : null}

          {isRunner ? (
            <>
              <ViewHeader title={runnerHubView.title} subtitle={runnerHubView.subtitle} />
              <WalletLinkCallout isAuthenticated={isAuthenticated} className={css.walletCallout} />
              <div id="noticeboard">
                <NoticeboardFeed isAuthenticated={isAuthenticated} className={css.noticeboardFeed} />
              </div>
            </>
          ) : null}

          {isHome ? (
            <>
              <WalletLinkCallout isAuthenticated={isAuthenticated} className={css.walletCallout} />
              <EndUserTradeTimeline
                isAuthenticated={isAuthenticated}
                className={css.tradeTimeline}
              />
              <div id="noticeboard">
                <NoticeboardFeed isAuthenticated={isAuthenticated} className={css.noticeboardFeed} />
              </div>
            </>
          ) : null}
        </div>
      </main>
      <FooterContainer />
    </Page>
  );
};

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { currentUser } = state.user;
  return {
    scrollingDisabled: isScrollingDisabled(state),
    isAuthenticated,
    currentUser,
  };
};

const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
